import { IconButton } from "@similarweb/ui-components";

import I18n from "pro-features/components/WithTranslation/src/I18n";
import { translate } from "app/filters/i18nFilter";
import { FIND_LEADS_SEARCH_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { StyledEmptySavedSearchContainer, StyledIcon, StyledTextBlock } from "./styles";

const EmptySavedSearchesContainer = () => {
    const handleFindNewLeadsClick = () => {
        proNavigator.go(FIND_LEADS_SEARCH_ROUTE);
    };

    return (
        <StyledEmptySavedSearchContainer>
            <StyledIcon iconName="empty-state-static-list-secondary" />
            <div>
                <I18n
                    dangerouslySetInnerHTML
                    component={StyledTextBlock}
                >
                    {"si.my-list.saved-searches.empty-state.description"}
                </I18n>
                <IconButton
                    type="primary"
                    iconName="search"
                    iconSize="xs"
                    onClick={handleFindNewLeadsClick}
                >
                    {translate("si.my-lists.saved-searches.button.find-new-leads")}
                </IconButton>
            </div>
        </StyledEmptySavedSearchContainer>
    );
};

export default EmptySavedSearchesContainer;
